import { Typography } from "@/components/ui/typography";
import { PricingPlans } from "@/components/screen/global-components/pricing";

type DocumentTranslationPricing3cardsProps = {
  title?: string;
  description?: string;
};

export default function DocumentTranslationPricing3cards({
  title,
  description,
}: DocumentTranslationPricing3cardsProps) {
  return (
    <section className="section">
      <div className="container mx-auto py-12 md:py-20 grid grid-cols-1 gap-6 lg:gap-12">
        <div className="flex flex-col justify-center gap-6 md:gap-2 md:w-full md:max-w-[800px] md:mx-auto">
          <Typography variant="heading4" className="text-center">
            <h2> {title}</h2>
          </Typography>
          <div className="flex justify-center text-gray-600">
            <Typography variant="subHeadingSm" className="text-center" asChild>
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <PricingPlans />
      </div>
    </section>
  );
}
